import { Info } from '@mui/icons-material';
import React, { useState } from 'react';
import { generateClassName } from './helpers';

import './InfoOnHover.css';

const InfoOnHover = ({ className = null, children }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div className={generateClassName('info-on-hover', '-container', className)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Info className={generateClassName('info-on-hover', '-icon', className)} />
            {isHovered && (
                <div className={generateClassName('info-on-hover', '-overlay', className)}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default InfoOnHover;